<div class="modal_dialog order-amount-details-modal">
  <div class="modal_header">
    <h2>{{ "OrderAmountDetails" | translate }}</h2>
    <button class="btnn close_icon" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

    <div class="modal_body">
    <!-- Compact Order Information -->
    <div class="order-info-compact">
      <div class="order-info-header">
        <h3>{{ "OrderNumber" | translate }}: <span class="order-number">#{{ data.data.orderNo || "---" }}</span></h3>
      </div>
    </div>

    <!-- Amount Breakdown Card -->
    <div class="info-card breakdown-card">
      <div class="card-header">
        <h3>{{ "AmountBreakdown" | translate }}</h3>
      </div>
      <div class="card-content">
        <div class="breakdown-items">
          <div class="breakdown-item">
            <span class="label">{{ "BasePriceOfProduct" | translate }}</span>
            <span class="value order-number">{{ (data.data.basePriceOfProduct || 0) | customCurrency }}</span>
          </div>
          <div class="breakdown-item">
            <span class="label">{{ "DeliveryFee" | translate }}</span>
            <span class="value order-number">{{ (data.data.deliveryFee || 0) | customCurrency }}</span>
          </div>
          <div class="breakdown-divider"></div>
          <div class="breakdown-item total-item">
            <span class="label total-label">{{ "SubTotal" | translate }}</span>
            <span class="value total-value">{{ (data.data.subTotal || 0) | customCurrency }}</span>
          </div>
          <div class="breakdown-divider" *ngIf="data.data.driverCommission || data.data.adminCommission || data.data.vendorCommission"></div>
          <div class="breakdown-item" *ngIf="data.data.driverCommission">
            <span class="label">{{ "DriverCommission" | translate }}</span>
            <span class="value order-number">{{ (data.data.driverCommission || 0) | customCurrency }}</span>
          </div>
          <div class="breakdown-item" *ngIf="data.data.adminCommission">
            <span class="label">{{ "AdminCommission" | translate }}</span>
            <span class="value order-number">{{ (data.data.adminCommission || 0) | customCurrency }}</span>
          </div>
          <div class="breakdown-item" *ngIf="data.data.vendorCommission">
            <span class="label">{{ "VendorCommission" | translate }}</span>
            <span class="value order-number">{{ (data.data.vendorCommission || 0) | customCurrency }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 